import { Injectable, ErrorHandler, Injector } from '@angular/core';

import { ErrorModalService } from './error-modal.service';
import { ErrorLoggerService } from './error-logger.service';

@Injectable({
    providedIn: 'root'
})
export class ErrorHandlerService implements ErrorHandler {
    constructor(private readonly injector: Injector, private readonly loggerService: ErrorLoggerService) {}

    handleError(error: any) {
        const modalService = this.injector.get(ErrorModalService);
        try {
            this.loggerService.handleError(error);
        } catch (e) {}
        try {
            modalService.handleError(error);
        } catch (e) {}
    }
}
